module.exports = __webpack_public_path__ + "static/USPoloRevised-e1203b424637099ac2409638a0e32d97.svg";